
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Punetonashikcab() {



  const cardData =
  {
    keyword: ' Pune to Nashik Cab',
    heading: 'SHREE Tours & Travels: Pune to Nashik Cab',
    headingDescription: 'SHREE Tours & Travels offers Pune to Nashik Cab service, providing a comfortable and hassle-free travel experience for business trips, pilgrimages and weekend getaways. Whether you need a one-way Cab, round trip, or outstation taxi, our well-maintained fleet ensures a smooth and enjoyable ride. With professional drivers, affordable pricing and flexible booking options, we make your journey to Nashik – the Wine Capital of India and home to Trimbakeshwar Jyotirlinga – convenient and stress-free. Choose SHREE Tours & Travels for the best Pune to Nashik Cab service.',

    top: 'Top Places to Visit in Nashik with SHREE Tours & Travels',

"topPlaces": [
    {
        "title": "Trimbakeshwar Temple",
        "description": "Trimbakeshwar Temple is one of the 12 Jyotirlingas in India and a highly revered pilgrimage site dedicated to Lord Shiva. Located at the foothills of the Brahmagiri mountains, this ancient temple is known for its unique three-faced Lingam symbolizing Brahma, Vishnu and Shiva. The temple is also the origin of the holy Godavari River, making it a sacred spot for devotees who perform rituals and seek spiritual solace."
    },
    {
        "title": "Sula Vineyards",
        "description": "Sula Vineyards is India's most famous wine estate, offering visitors a delightful experience of wine tasting, vineyard tours and gourmet dining. Spread across lush green landscapes, the vineyard provides insights into the winemaking process while allowing visitors to enjoy exquisite wines with a scenic backdrop. The annual SulaFest, featuring music, food and wine, makes it a must-visit destination for wine lovers and travelers alike."
    },
    {
        "title": "Panchvati",
        "description": "Panchvati is a sacred site in Nashik associated with the epic Ramayana. It is believed that Lord Rama, Goddess Sita and Lakshmana stayed here during their exile. The area is home to various temples and holy spots, including Kalaram Temple, Sita Gufa (cave) and the sacred Godavari River ghats. Devotees visit Panchvati to experience the spiritual ambiance and explore its mythological significance."
    },
    {
        "title": "Saptashrungi Devi Temple",
        "description": "Perched on a hill at an altitude of 1,230 meters, Saptashrungi Devi Temple is one of the 51 Shakti Peethas and a major pilgrimage site near Nashik. The temple, dedicated to Goddess Saptashrungi, is surrounded by seven mountain peaks, offering breathtaking views. Devotees undertake a scenic trek or use a ropeway to reach the temple, seeking blessings and admiring the divine aura of the place."
    },
    {
        "title": "Kalaram Temple",
        "description": "Kalaram Temple is one of the most important temples in Nashik, known for its striking black stone idol of Lord Rama. The temple’s architecture features intricate carvings and a grand entrance, drawing thousands of devotees every year. The temple has historical significance as it was part of India's freedom movement, where leaders like Dr. B.R. Ambedkar advocated for social reforms."
    },
    {
        "title": "Anjneri Hill",
        "description": "Anjneri Hill is believed to be the birthplace of Lord Hanuman and is a popular trekking destination near Nashik. The hill offers a picturesque landscape with lush greenery, waterfalls and caves. Adventure seekers and devotees alike visit Anjneri for its scenic trekking trails and spiritual significance, making it an excellent place for nature lovers and religious travelers."
    },
    {
        "title": "Ram Kund",
        "description": "Ram Kund is a sacred bathing ghat on the Godavari River, where devotees take a holy dip to cleanse their sins. It is believed that Lord Rama bathed here during his exile, making it an essential religious site in Nashik. The ghat also serves as the venue for various Hindu rituals and ceremonies, including the immersion of ashes of departed souls."
    },
    {
        "title": "Someshwar Waterfalls",
        "description": "Someshwar Waterfalls, also known as Dudhsagar Waterfalls (not to be confused with Goa’s Dudhsagar), is a serene natural attraction near Nashik. Located close to the Someshwar Temple, the waterfall cascades down from a height, creating a misty and picturesque environment. The surrounding greenery and cool climate make it a perfect spot for picnics and nature walks."
    },
    {
        "title": "Pandavleni Caves",
        "description": "Pandavleni Caves are a group of 24 ancient rock-cut caves dating back to the 2nd century BC, showcasing the rich history of Buddhism in Nashik. These caves contain intricate carvings, stupas and prayer halls used by Buddhist monks for meditation. The trek to the caves offers panoramic views of Nashik, making it a great combination of history, spirituality and adventure."
    },
    {
        "title": "Coin Museum",
        "description": "The Coin Museum in Nashik is a unique attraction for history and numismatics enthusiasts. It houses a vast collection of coins, currency and artifacts from different eras of Indian history, including the Mauryan, Mughal and British periods. The museum provides insights into the evolution of trade, economy and culture through its extensive displays, making it an educational and fascinating visit."
    }
],  
    
            
"services": [
    {
      "name": "Pune to Nashik Taxi",
      "description": "Travel comfortably with SHREE Tours & Travels by booking a taxi from Pune to Nashik. Our well-maintained vehicles and professional drivers ensure a smooth and hassle-free journey to Nashik's famous temples and scenic spots."
    },
    {
      "name": "Pune to Nashik Cab Service",
      "description": "Looking for a reliable Cab service from Pune to Nashik? SHREE Tours & Travels offers affordable one-way and round-trip Cab options with comfortable seating and experienced drivers for a stress-free ride."
    },
    {
      "name": "Pune to Nashik One-Way Taxi",
      "description": "Need a one-way taxi from Pune to Nashik? Book with SHREE Tours & Travels for a convenient and cost-effective ride. Enjoy a smooth journey without hidden charges and travel at your own pace."
    },
    {
      "name": "Pune to Nashik Round Trip Cab",
      "description": "Planning a round-trip to Nashik? Our round-trip Cab service offers flexible options for travelers who need to return on the same day or after a few days, ensuring a comfortable and enjoyable journey."
    },
    {
      "name": "Affordable Pune to Nashik Cab",
      "description": "Get budget-friendly Cab services from Pune to Nashik without compromising on quality and comfort. Enjoy a reliable and smooth travel experience at the best prices with SHREE Tours & Travels."
    },
    {
      "name": "Private Taxi for Nashik from Pune",
      "description": "Book a private taxi from Pune to Nashik for a personalized and comfortable travel experience. Enjoy privacy, comfort and a seamless journey with SHREE Tours & Travels tailored to your schedule."
    },
    {
      "name": "Nashik Temple Tour by Cab",
      "description": "Planning a Nashik temple tour? Our Cab service ensures a comfortable and convenient trip to Nashik’s famous temples, including the Trimbakeshwar Temple, with professional drivers and reliable transportation."
    },
    {
      "name": "Nashik Cab Hire",
      "description": "Hire a Cab from Pune to Nashik with SHREE Tours & Travels. Choose from a variety of cars, from budget to luxury and enjoy a safe and comfortable ride to Nashik’s attractions."
    },
    {
      "name": "Group Travel from Pune to Nashik",
      "description": "Traveling with a group? Book our spacious and comfortable Cabs for a smooth group travel experience from Pune to Nashik. Enjoy a shared journey with friends or family in a well-maintained vehicle."
    },
    {
      "name": "Book Pune to Nashik Car",
      "description": "Rent a car for your Pune to Nashik journey with ease. Choose from sedans, SUVs and tempo travelers for a comfortable ride and enjoy a hassle-free trip to Nashik’s scenic and religious landmarks."
    },
    {
      "name": "Nashik Cab Booking from Pune",
      "description": "Easily book a Cab from Pune to Nashik with SHREE Tours & Travels. Our online booking service makes it simple to schedule a convenient pick-up, ensuring timely service and a smooth journey."
    },
    {
      "name": "Pune to Nashik Weekend Taxi",
      "description": "Planning a weekend getaway? Our Pune to Nashik weekend taxi service allows you to explore the temples, vineyards and natural beauty of Nashik at your own pace with a comfortable and reliable ride."
    },
    {
      "name": "Nashik Sightseeing Cab",
      "description": "Explore the beauty of Nashik with our sightseeing Cab service. Visit popular attractions like the Panchavati, Saptashrungi Temple and more with an experienced driver guiding you through the city's highlights."
    },
    {
      "name": "Nashik to Pune Cab Service",
      "description": "Returning from Nashik to Pune? Book our reliable Nashik to Pune Cab service for a comfortable, safe and timely journey. Enjoy seamless transportation with SHREE Tours & Travels."
    },
    {
      "name": "Luxury Nashik Taxi",
      "description": "Experience a premium travel experience with our luxury taxi service from Pune to Nashik. Choose high-end vehicles like Innova Crysta, Mercedes, or premium sedans for a lavish ride."
    },
    {
      "name": "Nashik Trip from Pune",
      "description": "Book your taxi for a memorable Nashik trip with SHREE Tours & Travels. Our Cabs are well-maintained and our drivers are experienced, ensuring a smooth and comfortable journey from Pune to Nashik."
    },
    {
      "name": "Nashik Tour by Cab",
      "description": "Plan your Nashik tour with SHREE Tours & Travels. Our Cab service covers all the essential attractions in Nashik, offering a comfortable ride and knowledgeable drivers for a convenient, hassle-free experience."
    }
  ],

  "tableData": [
    ["- Pune to Nashik Taxi", "- Pune to Nashik Cab Service"],
    ["- Pune to Nashik One-Way Taxi", "- Pune to Nashik Round Trip Cab"],
    ["- Affordable Pune to Nashik Cab", "- Private Taxi for Nashik from Pune"],
    ["- Nashik Temple Tour by Cab", "- Nashik Cab Hire"],
    ["- Group Travel from Pune to Nashik", "- Book Pune to Nashik Car"],
    ["- Nashik Cab Booking from Pune", "- Pune to Nashik Weekend Taxi"],
    ["- Nashik Sightseeing Cab", "- Nashik to Pune Cab Service"],
    ["- Luxury Nashik Taxi", "- Nashik Trip from Pune"],
    ["- Nashik Tour by Cab"]
  ],

  
  whychoose: [
    {
      "WhyChooseheading": "Comfortable Journey",
      "WhyChoosedescription": "Our Pune to Shirdi Cabs are designed to offer you a comfortable and relaxing journey. With spacious seating, air-conditioning and smooth driving, you can enjoy a stress-free trip. Whether you're traveling for religious purposes or simply to explore, we ensure a pleasant experience throughout your ride."
    },
    {
      "WhyChooseheading": "Experienced Drivers",
      "WhyChoosedescription": "Our experienced drivers are familiar with the Pune to Shirdi route and are committed to providing you with a safe and timely trip. They prioritize your safety and comfort while ensuring a smooth journey. With their local expertise, you can trust that you’re in good hands during your trip."
    },
    {
      "WhyChooseheading": "Affordable Pricing",
      "WhyChoosedescription": "We offer competitive and affordable pricing for your Pune to Shirdi Cab ride. With no hidden charges and transparent pricing, we guarantee great value without compromising on service quality. Whether you're booking a one-way or round trip, our pricing options ensure a budget-friendly solution."
    },
    {
      "WhyChooseheading": "Well-Maintained Vehicles",
      "WhyChoosedescription": "All our vehicles are regularly serviced and maintained to the highest standards, ensuring a smooth and safe journey. From cleanliness to mechanical performance, we take great care in keeping our fleet in top condition, providing you with a reliable and comfortable ride."
    },
    {
      "WhyChooseheading": "Flexible Rental Options",
      "WhyChoosedescription": "We understand that every traveler has different needs, which is why we offer flexible rental packages for your Pune to Shirdi trip. Whether you need a Cab for a few hours, a full day, or multiple days, we can customize the rental to meet your requirements and schedule."
    },
    {
      "WhyChooseheading": "Easy Booking Process",
      "WhyChoosedescription": "Booking a Cab for your Pune to Shirdi trip is quick and easy with SHREE Tours & Travels. You can easily book online via our user-friendly platform or contact our customer service team for personalized assistance. Whether you're planning ahead or need a last-minute booking, we make the process hassle-free."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "We offer 24/7 availability for your Pune to Shirdi Cab needs. Whether you need an early morning ride or a late-night pickup, we are always here to accommodate your schedule. Our round-the-clock service ensures that we’re ready to serve you at any time."
    },
    {
      "WhyChooseheading": "Local Insights",
      "WhyChoosedescription": "Our drivers have extensive local knowledge and can provide useful insights into the best routes and attractions in and around Shirdi. If you're interested in sightseeing or need recommendations for places to visit, they are happy to share their expertise and enhance your journey."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "Customer satisfaction is our top priority at SHREE Tours & Travels. We are committed to providing exceptional service and ensuring that your Pune to Shirdi trip is comfortable, safe and enjoyable. With a focus on quality service and customer care, we guarantee a smooth and hassle-free experience."
    }
  ]
  
  
  
  
  
  
  



        
  }

  const faqData = [
    {
        question: "How can I book a Cab from Pune to Shirdi?",
        answer: "You can easily book your Pune to Shirdi Cab through our website or by calling our customer service for assistance."
    },
    {
        question: "What types of Cabs do you offer for the Pune to Shirdi route?",
        answer: "We offer a variety of vehicles for the Pune to Shirdi journey, including sedans, SUVs and MPVs, to suit your preferences and group size."
    },
    {
        question: "Are the rental rates from Pune to Shirdi inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. Detailed pricing information will be provided during the booking process."
    },
    {
        question: "Can I book a Cab for a one-way trip from Pune to Shirdi?",
        answer: "Yes, we offer one-way rental options for your Pune to Shirdi trip."
    },
    {
        question: "Do you provide drivers with the rental Cab for the Pune to Shirdi trip?",
        answer: "Yes, all our Cabs come with experienced drivers who are familiar with the route to ensure a safe and comfortable journey."
    },
    {
        question: "What is your cancellation policy for a Pune to Shirdi Cab booking?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for the Pune to Shirdi Cab booking?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the vehicles insured for the Pune to Shirdi trip?",
        answer: "Yes, all our vehicles come with insurance coverage for your safety while traveling."
    },
    {
        question: "Can I request a child seat for my Cab from Pune to Shirdi?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for booking a Cab from Pune to Shirdi?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'The Pune to Shirdi trip was fantastic! The driver was very professional and the ride was smooth and comfortable.',
        name: 'Mr. Sunil Deshmukh',
    },
    {
        text: 'I had a great experience with SHREE Tours & Travels. The ride to Shirdi was pleasant and the driver was extremely courteous.',
        name: 'Miss. Radhika Patil',
    }
];







  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];


const schemaData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SHREE Tours & Travels",
  "description": "Book a comfortable and reliable Cab from Pune to Nashik with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Your office address here",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "telephone": "+91-9594917913",
  "url": "https://shreetoursandtravels.in",
  "logo": "https://shreetoursandtravels.in/img/logo.jpg",
  "image": [
    "https://shreetoursandtravels.in/img/pune-to-nashik-cab.jpg",
    "https://shreetoursandtravels.in/img/nashik-tour-cab.jpg"
  ],
  "priceRange": "₹2500 - ₹5500",
  "offers": {
    "@type": "Offer",
    "url": "https://shreetoursandtravels.in/pune-to-nashik-cab-service",
    "priceCurrency": "INR",
    "price": 3000,
    "priceValidUntil": "2025-12-31"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": 4.7,
    "reviewCount": 2100
  },
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Anil Yadav"
      },
      "datePublished": "2024-08-15",
      "reviewBody": "Wonderful experience! The Cab was very comfortable and the driver was friendly and knowledgeable. Highly recommended for Nashik trips!"
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Meenal Joshi"
      },
      "datePublished": "2024-09-12",
      "reviewBody": "Great trip to Nashik! The service was excellent and the ride was smooth. A reliable service provider for any trip to Nashik."
    }
  ],
  "serviceArea": {
    "@type": "Place",
    "name": "Pune to Nashik Cab Service",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 19.9975,  // Nashik latitude
      "longitude": 73.7898  // Nashik longitude
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://shreetoursandtravels.in/pune-to-nashik-cab-service"
  },
  "keywords": "Pune to Nashik Taxi, Pune to Nashik Cab Service, Pune to Nashik One-Way Taxi, Pune to Nashik Round Trip Cab, Affordable Pune to Nashik Cab, Private Taxi for Nashik from Pune, Nashik Temple Tour by Cab, Nashik Cab Hire, Group Travel from Pune to Nashik, Book Pune to Nashik Car, Nashik Cab Booking from Pune, Pune to Nashik Weekend Taxi, Nashik Sightseeing Cab, Nashik to Pune Cab Service, Luxury Nashik Taxi, Nashik Trip from Pune, Nashik Tour by Cab"
};



  return (
    <div>
      <GoogleAnalytics/>
    <Helmet>
  <title>Pune to Nashik Cab Service | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Book a comfortable and reliable Cab from Pune to Nashik with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!" />
  <meta name="keywords" content="Pune to Nashik Taxi, Pune to Nashik Cab Service, Pune to Nashik One-Way Taxi, Pune to Nashik Round Trip Cab, Affordable Pune to Nashik Cab, Private Taxi for Nashik from Pune, Nashik Temple Tour by Cab, Nashik Cab Hire, Group Travel from Pune to Nashik, Book Pune to Nashik Car, Nashik Cab Booking from Pune, Pune to Nashik Weekend Taxi, Nashik Sightseeing Cab, Nashik to Pune Cab Service, Luxury Nashik Taxi, Nashik Trip from Pune, Nashik Tour by Cab" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>

    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/7.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetonashikcab;